export default "/_next/static/chunks/fonts/DMMono-Regular-e030114f04abc025ebac65863629664d.woff";